import { buildBaseOptions } from '../base_options'

export const SmoothLineVariant = {
  chartType: 'line',

  applyDataDefaults(datasets) {
    datasets.forEach((dataset) => {
      dataset.borderWidth ??= 2
      dataset.tension ??= 0.45
      dataset.pointRadius ??= 0
      dataset.fill ??= false
      dataset.backgroundColor ??= 'transparent'
    })
  },

  buildOptions(options = {}) {
    return buildBaseOptions(options)
  },
}
